import * as LocationActions from './templateLocation.actions';

export { LocationActions };
